import ChungTuPhatHanhPage from "./ChungTuPhatHanhPage";

export default ChungTuPhatHanhPage;
